import { mapMutations } from 'vuex';

export const mixinGlobal = {
	data(){
		return{
		}
	},
  computed:{
    /*...mapMutations( ['mutateErrorText'] ),*/
  },
  methods: {
    toCurrency: (value) => { 
      value = parseFloat(value).toFixed(2) // always two decimal digits
      value = value.replace(".", ",") // replace decimal point character with ,
      value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €" // use . as a separator
      return value;
      //parseFloat(value).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }) 
    },
    toDecimal: (value) => {
      return Math.round( value * 1e2 ) / 1e2;
    },
    convertDate: (inputDate, time = false) =>  {
      if( !inputDate ){
        return ""
      }else{
        var date = new Date(inputDate)
        if( !time ){      
          return ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();
        }else{
          return ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2) + ":" + ("0" + date.getSeconds()).slice(-2) + " " + ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear();
        }
      }
    },
    
    startLoading(){ this.loading = true; },

    stopLoading(){  this.loading = false;},

    getRouteLineId(){ return this.getRouteParams.lin.substr(0, this.getRouteParams.lin.indexOf('-')); },

    getRouteCategoryId(){ return this.getRouteParams.ctg.substr(0, this.getRouteParams.ctg.indexOf('-')); },

    getRouteSubcategoryId(){ return this.getRouteParams.sct.substr(0, this.getRouteParams.sct.indexOf('-')); },

    getRouteTypeId(){ return this.getRouteParams.typ.substr(0, this.getRouteParams.typ.indexOf('-')); },

    getRouteLineName(){ return this.getRouteParams.lin.substr(this.getRouteParams.lin.indexOf('-')+1, this.getRouteParams.lin.length).toLowerCase(); },
    
    setUrlParams(id, value){
      var normalize = (function() {
        var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç", 
        to   = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
        mapping = {};

        for(var i = 0, j = from.length; i < j; i++ )
            mapping[ from.charAt( i ) ] = to.charAt( i );
       
        return function( str ) {
          var ret = [];
          for( var i = 0, j = str.length; i < j; i++ ) {
            var c = str.charAt( i );
            if( mapping.hasOwnProperty( str.charAt( i ) ) )
                ret.push( mapping[ c ] );
            else
                ret.push( c );
          }      
          return ret.join( '' ).replace( /[^-A-Za-z0-9]+/g, '-' )
        }       
      })();
      
      return normalize( id + '-' + value);
    },
    checkResponseData(data){
      if ( this.isObject(data.data) ) {    
        return true;   
      }else{
        return false;
      } 
    },
    isObject(val) {
      if (val === null) { return false;}
      return ( (typeof val === 'function') || (typeof val === 'object') );
    },
    isEmailValid(val){
      var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if( val.match(mailformat) ){
        return true
      }else{
        return false
      }
    }
  },
}